// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/main.css
// module id = 1160
// module chunks = 0